import React, { useState } from 'react'
import { Badge, Button, Paper, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import {
  HelpOutline,
  MailOutline,
  SearchOutlined,
  ViewListOutlined,
} from '@material-ui/icons'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import { hasPermission } from 'utils'
import { Message } from 'services/api'
import api from 'services/api/PublicPrescription'
import {
  basePath,
  LoadState,
  Page,
  Rules,
  publicMessagesPath,
  useClock,
} from './PublicPrescriptionShared'
import { requestStatus, tehranTime } from './publicPrescriptionModel'

const messages = new Message()
const PublicPrescriptionHome: React.FC = () => {
  const [rules, setRules] = useState(false)
  const now = useClock()
  const canList = hasPermission('prescription:getprescriptionofuser')
  const requests = useQuery('public-prescription-summary', api.all, {
    enabled: canList,
    retry: false,
    refetchInterval: 30000,
    refetchIntervalInBackground: false,
  })
  const unread = useQuery(
    'public-prescription-unread',
    () => messages.getUserMessages(true, 0, 1),
    {
      retry: false,
      refetchInterval: 60000,
      refetchIntervalInBackground: false,
    },
  )
  const active = (requests.data || []).filter(
    (item) => requestStatus(item, now).active,
  )
  return (
    <Page
      title="داروگ | جستجوی دارو"
      subtitle="برای ثبت درخواست جدید یا پیگیری درخواست‌های قبلی، یکی از گزینه‌های زیر را انتخاب کنید."
    >
      <Paper className="request-card home-hero">
        <h2 className="section-title">
          داروی مورد نیازتان را با کمک داروگ پیدا کنید
        </h2>
        <Typography>
          ثبت و جستجو رایگان است. درخواست شما تا ۴۸ ساعت در محدوده‌ای که انتخاب
          می‌کنید پیگیری می‌شود.
        </Typography>
      </Paper>
      <LoadState
        loading={canList && requests.isLoading}
        error={requests.error}
        retry={(): void => {
          requests.refetch()
        }}
      />
      {active.length > 0 && (
        <Alert severity="info">
          <strong>
            {active.length.toLocaleString('fa-IR')} درخواست فعال دارید.
          </strong>
          {active.length === 1 && (
            <>
              <br />
              {active[0].comment} · {requestStatus(active[0], now).label}
              <br />
              {Math.max(
                0,
                Math.floor((now - tehranTime(active[0].sendDate)) / 3600000),
              ).toLocaleString('fa-IR')}{' '}
              ساعت از ثبت گذشته است.
            </>
          )}
          <br />
          برای مشاهدهٔ جزئیات،{' '}
          <Link to={`${basePath}/my`}>«درخواست‌های من»</Link> را انتخاب کنید.
        </Alert>
      )}
      <div className="home-options">
        {hasPermission('prescription:sendpublic') && (
          <Button
            className="primary-action"
            component={Link}
            to={`${basePath}/new`}
            variant="contained"
            startIcon={<SearchOutlined />}
          >
            جستجوی داروی جدید
          </Button>
        )}
        {canList && (
          <Button
            component={Link}
            to={`${basePath}/my`}
            variant="outlined"
            color="primary"
            startIcon={<ViewListOutlined />}
          >
            درخواست‌های من
          </Button>
        )}
        <Button
          component={Link}
          to={publicMessagesPath}
          variant="outlined"
          color="primary"
          startIcon={
            <Badge badgeContent={unread.data?.count || 0} color="secondary">
              <MailOutline />
            </Badge>
          }
        >
          پیام‌های من
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<HelpOutline />}
          onClick={(): void => setRules(true)}
        >
          راهنما و قوانین
        </Button>
      </div>
      <Rules open={rules} onClose={(): void => setRules(false)} />
    </Page>
  )
}
export default PublicPrescriptionHome
